export const version = "wallet/5.5.0";
//# sourceMappingURL=_version.js.map